import { Check } from "lucide-react";
import { businessConfig } from "@/config";

const ITEMS = [
  { bold: "Master Groomer–certified.", light: "Years of expertise." },
  { bold: "Rescue partners.", light: "Proudly with Running Wild." },
  { bold: "Cats welcome too.", light: "One of few in Moose Jaw." },
  { bold: "Family-vibe team.", light: "Same friendly faces." },
];

export default function WhyFamiliesSection() {
  const groomer = businessConfig.media?.polaroidGroomer;
  const happy = businessConfig.media?.polaroidHappyDog;
  return (
    <section className="why-families" id="why" data-testid="why-families">
      <div className="why-families__inner">
        <div className="why-families__photos">
          <figure className="polaroid polaroid--left" aria-hidden>
            {groomer ? (
              <div className="polaroid__photo">
                <img src={groomer} alt="" loading="lazy" data-testid="polaroid-groomer" />
              </div>
            ) : (
              <div className="polaroid__placeholder polaroid__placeholder--groomer">
                <span className="polaroid__caption">groomer photo</span>
              </div>
            )}
          </figure>
          <figure className="polaroid polaroid--right" aria-hidden>
            {happy ? (
              <div className="polaroid__photo">
                <img src={happy} alt="" loading="lazy" data-testid="polaroid-happy-dog" />
              </div>
            ) : (
              <div className="polaroid__placeholder polaroid__placeholder--happy-dog">
                <span className="polaroid__caption">happy dog</span>
              </div>
            )}
          </figure>
        </div>

        <div className="why-families__copy">
          <span className="overline" >WHY FAMILIES CHOOSE US</span>
          <h2 className="section-h2">Treated as our own. Loved like family.</h2>
          <ul className="why-families__grid">
            {ITEMS.map((item) => (
              <li key={item.bold} className="why-families__item">
                <Check className="w-5 h-5 flex-shrink-0" style={{ color: "var(--pp-gold)" }} strokeWidth={2.5} />
                <span>
                  <strong>{item.bold}</strong>
                  <span className="why-families__light"> {item.light}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
